import React, { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";

export default function StaffLogin() {
  const { user, login, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation() as { state?: { from?: Location } };
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  if (!loading && user) {
    const dest = (location.state?.from as unknown as { pathname?: string })?.pathname ?? "/app";
    return <Navigate to={dest} replace />;
  }

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await login(email, password);
      navigate("/app");
    } catch {
      setError("E-mail ou senha inválidos.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="nt-login">
      <section className="nt-login-side">
        <div className="nt-brand">
          <span className="nt-mark">S+</span>
          <span>
            <strong>Software Plus</strong>
            <small>Financeiro</small>
          </span>
        </div>
        <h1>Contratos, cobranças e contas a pagar no mesmo livro.</h1>
        <div className="nt-ledger" aria-label="O que o sistema faz">
          <div>
            <b>01</b>
            <span>Títulos a receber gerados todo dia 1, vencendo no dia de cobrança de cada contrato.</span>
          </div>
          <div>
            <b>02</b>
            <span>Contrato em PDF pronto assim que o contrato é cadastrado.</span>
          </div>
          <div>
            <b>03</b>
            <span>Orçamentos por hora, com valor por nível de habilidade.</span>
          </div>
        </div>
        <div className="nt-login-foot">© {new Date().getFullYear()} Software Plus</div>
      </section>

      <main className="nt-login-main">
        <form className="nt-login-card" onSubmit={handleSubmit}>
          <div>
            <h2 className="m-0" style={{ fontSize: 22 }}>
              Entrar
            </h2>
            <p className="m-0 mt-1 text-secondary" style={{ fontSize: 13.5 }}>
              Acesso da equipe interna.
            </p>
          </div>

          <div>
            <label htmlFor="email" className="form-label">
              E-mail
            </label>
            <input
              id="email"
              type="email"
              className="form-control"
              placeholder="nome@softwareplus.com.br"
              autoComplete="username"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div>
            <label htmlFor="password" className="form-label">
              Senha
            </label>
            <input
              id="password"
              type="password"
              className="form-control"
              placeholder="••••••••"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          {error && (
            <div className="text-danger" style={{ fontSize: 12.5 }}>
              {error}
            </div>
          )}

          <button type="submit" className="btn btn-primary btn-lg w-100" disabled={submitting}>
            {submitting ? "Entrando…" : "Entrar"}
          </button>
          <p className="m-0 text-secondary" style={{ fontSize: 12 }}>
            Problemas com o acesso? Fale com um administrador do sistema.
          </p>
        </form>
      </main>
    </div>
  );
}
